const { windowLoaded } = require('@grpn/document-states');
const { default: preactClient } = require('app/desktop/client');

windowLoaded.then(() => {
  preactClient();
});

//Do not remove or hash on dynamic imports will not update
export default () => {};
